import { v4 as uuidv4 } from 'uuid';
import { version } from '../components/header/package.json';
import type { ReactiveController, ReactiveControllerHost } from "lit";

export class ContentServiceController implements ReactiveController {
    host: ReactiveControllerHost;
    private readonly environment: string;
    private readonly JSON_CONTENT_HASH = 'c00a1644ec7c70b925a0b9b3ea291c261546a05d7484958915b6d8a5b32cc62d';

    constructor(host: ReactiveControllerHost, environment: string) {
        (this.host = host).addController(this);
        this.environment = environment;
    }

    hostConnected() {
    }

    async fetchData(locale: string, content: string, client_id: string, type: string): Promise<any> {
        const transactionId = uuidv4();
        const baseUrl = this.getUrlBasedOnEnvironment(this.environment);

        const body = {
            variables: { locale, content },
            extensions: {
                persistedQuery: {
                    version: 1,
                    sha256Hash: this.JSON_CONTENT_HASH,
                },
            },
        };

        try {
            const graphqlResponse = await fetch(`${baseUrl}/services/graphql`, {
                method: 'POST',
                headers: {
                    'apollographql-client-name': `${client_id}-content-service`,
                    'apollographql-client-version': version,
                    'Content-Type': 'application/json',
                    'X-Transactionid': transactionId,
                },
                body: JSON.stringify(body),
            });

            if (!graphqlResponse.ok) {
                throw new Error(`GraphQL request failed: ${graphqlResponse.status} ${graphqlResponse.statusText}`);
            }

            const result = await graphqlResponse.json();
            const url = result?.data?.staticContent?.url;

            if (!url) {
                throw new Error('No staticContent URL in response');
            }

            const contentResponse = await fetch(`/pubcontent${url}`);
            if (!contentResponse.ok) {
                throw new Error(`Content request failed: ${contentResponse.status} ${contentResponse.statusText}`);
            }

            return contentResponse.json();
        } catch (error) {
            throw new Error(`Failed to fetch JSON: ${error}`);
        }
    }

    getUrlBasedOnEnvironment(environment: string): string {
        let graphURL = 'https://www.aa.com';
        if (environment === 'qa' || environment === 'test' || environment.toLowerCase().includes('local')) {
            graphURL = window.location.origin;
        } else if (environment === 'stage') {
            graphURL = 'https://stage.aa.com';
        }
        return graphURL;
    }
}
